<div class="sticky-banner">
    <app-sponsor-banner [margin]="'0.6rem 0 0 0'" [location]="'Golf Tournament Details'" [sponsor_key]="'tournament-details-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>
</div>

<h2 class="center">{{ entry.name }}</h2>

@if (golfTour?.tournament_type !== 'ryder_cup') {
    @if (hasPurse) {
        <div class="center">
            <app-app-string style="font-weight: 900" [key_name]="'golf.purse'"></app-app-string>
            {{ golfTour?.purse }}
        </div>
    }
    @if (golfTour?.cut !== null && golfTour?.cut !== undefined) {
        <div class="center">
            <app-app-string style="font-weight: 900" [key_name]="'golf.tournament.cut'"></app-app-string>
            {{ golfTour?.cut }}
        </div>
    }
} @else {
    <div class="center" style="margin: 0.25rem 1rem 0; line-height: 1.35">
        <app-app-string [key_name]="'golf.rydercup.overview.description'"></app-app-string>
    </div>
}

<div style="margin-top: 1rem">
    <app-weather [Course]="golfTour?.courses"></app-weather>
</div>

<h2 class="center" style="margin-top: 1rem">
    <app-app-string [key_name]="'golf.tournament.details.course.overview'"></app-app-string>
</h2>

<section class="course-container">
    @for (course of golfTour?.courses; track course; let i = $index) {
        <section class="course-details-card" [class.expanded]="expanded[i]">
            <div class="course-info" (click)="toggle($event, i, course)" [ngStyle]="hasHoles(course) ? { cursor: 'pointer' } : {}">
                <div class="course-name">
                    {{ course.name }}
                    @if (formatCourseAbbreviation(course?.course_abbreviation)) {
                        <span>
                            {{ formatCourseAbbreviation(course?.course_abbreviation) }}
                        </span>
                    }
                </div>
                <div class="course-location">{{ course.city }}</div>
                <div class="divider-line"></div>
                <div
                    class="course-specs"
                    [style.justify-content]="!course.holes?.length ? 'space-around' : null"
                    [style.margin-bottom]="expanded[i] && course.holes?.length ? '1rem' : null"
                >
                    <div class="spec">
                        <div class="label">
                            <app-app-string [key_name]="'golf.par'"></app-app-string>
                        </div>
                        <div class="value">{{ course.total_par ?? '-' }}</div>
                    </div>
                    <div class="spec">
                        <div class="label">
                            <app-app-string [key_name]="'golf.hole.distance'"></app-app-string>
                        </div>
                        <div class="value">
                            @if (isMetric) {
                                {{ course.total_length?.meters ?? '-' }}
                                @if (course.total_length?.meters) {
                                    <app-app-string [key_name]="'golf.hole.distance.meters'"></app-app-string>
                                }
                            } @else {
                                {{ course.total_length?.yards ?? '-' }}
                                @if (course.total_length?.yards) {
                                    <app-app-string [key_name]="'golf.hole.distance.yards'"></app-app-string>
                                }
                            }
                        </div>
                    </div>
                    @if (course.holes?.length) {
                        <div class="ellipsis-wrapper" [style.visibility]="expanded[i] ? 'hidden' : 'visible'">
                            <img (click)="toggle($event, i, course)" class="ellipsis" src="assets/golf/ellipsis.circle.svg" alt="more" />
                        </div>
                    }
                </div>
            </div>
            @if (expanded[i] && course.holes?.length) {
                <div class="course-expanded-content">
                    @if (canShowStatsTab(course)) {
                        <div class="course-tabs" role="tablist">
                            <button
                                type="button"
                                class="course-tab"
                                [class.active]="getSelectedTab(course) === 'overview'"
                                (click)="setSelectedTab(course, 'overview')"
                            >
                                {{ getTabLabel('overview') }}
                            </button>
                            <button
                                type="button"
                                class="course-tab"
                                [class.active]="getSelectedTab(course) === 'stats'"
                                (click)="setSelectedTab(course, 'stats')"
                            >
                                {{ getTabLabel('stats') }}
                            </button>
                        </div>
                    }

                    @if (getSelectedTab(course) === 'stats' && canShowStatsTab(course)) {
                        <div class="stats-picker-row">
                            <select
                                class="stats-round-select"
                                [value]="getSelectedStatsRound(course) ?? ''"
                                (change)="onStatsRoundChange(course, $event)"
                                aria-label="Course stats round"
                            >
                                @for (option of getStatsRoundOptions(course); track option.key) {
                                    <option [value]="option.key">
                                        {{ getStatsRoundLabel(option.key) }}
                                    </option>
                                }
                            </select>
                        </div>

                        <div class="hole-table-container">
                            <table class="hole-table stats-table">
                                <tr>
                                    <th><app-app-string [key_name]="'golf.hole'"></app-app-string></th>
                                    @for (h of course.holes; track h) {
                                        <td>{{ h.hole }}</td>
                                    }
                                </tr>
                                @for (row of getStatsRows(course); track row.key) {
                                    <tr>
                                        <th>
                                            <span class="label-full">{{ getStatsLabel(row.key) }}</span>
                                            <span class="label-short">{{ getStatsLabel(row.key, true) }}</span>
                                        </th>
                                        @for (value of row.values; track $index) {
                                            <td [class]="getCourseStatClass(row.key, value)">
                                                {{ displayCourseStat(value) }}
                                            </td>
                                        }
                                    </tr>
                                }
                            </table>
                        </div>
                    } @else {
                        <div class="hole-table-container">
                            <table class="hole-table">
                                <tr>
                                    <th><app-app-string [key_name]="'golf.hole'"></app-app-string></th>
                                    @for (h of course.holes; track h) {
                                        <td>{{ h.hole }}</td>
                                    }
                                </tr>
                                <tr>
                                    <th><app-app-string [key_name]="'golf.par'"></app-app-string></th>
                                    @for (h of course.holes; track h) {
                                        <td>{{ h.par }}</td>
                                    }
                                </tr>
                                <tr>
                                    <th>
                                        @if (isMetric) {
                                            <app-app-string [key_name]="'golf.hole.distance.meters'"></app-app-string>
                                        } @else {
                                            <app-app-string [key_name]="'golf.hole.distance.yards'"></app-app-string>
                                        }
                                    </th>
                                    @for (h of course.holes; track h) {
                                        <td>
                                            {{ isMetric ? h.length?.meters : h.length?.yards }}
                                        </td>
                                    }
                                </tr>
                            </table>
                        </div>
                    }
                </div>
            }
        </section>
    }
</section>
